import React from "react"
import UpdateProfile from "../components/UpdateProfile";


const UpdateProfilePage: React.FC = () => {
    return (
        <div>
            <UpdateProfile/>
        </div>
    )
}

export default UpdateProfilePage;